import { render, staticRenderFns } from "./InlineChannelSelect.vue?vue&type=template&id=7062978c&scoped=true"
import script from "./InlineChannelSelect.vue?vue&type=script&lang=js"
export * from "./InlineChannelSelect.vue?vue&type=script&lang=js"
import style0 from "./InlineChannelSelect.vue?vue&type=style&index=0&id=7062978c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7062978c",
  null
  
)

export default component.exports